import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Layers from './components/Layers';
import HotRank from './components/HotRank';
import Categories from './components/Categories';
import Topics from './components/Topics';
import Columns from './components/Columns';
import TagCloud from './components/TagCloud';
import Updates from './components/Updates';
import Faq from './components/Faq';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BackTop from './components/BackTop';

export default function Home() {
  return (
    <div className="bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <HotRank />
        <Layers />
        <Categories />
        <Topics />
        <Columns />
        <TagCloud />
        <Updates />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}